import {PersonLogin} from "../person/person-login";

export class ShippingChargeTaskResponse {

  taskId!: number;
  responder!: PersonLogin;
  additionalData!: string;
  approved!: boolean;
  shippingCharge!: number;
  stateCode!: string;

}
